import { Navigate } from 'react-router-dom'
import type { ReactNode } from 'react'
// import type { Role } from '@/api/auth'
import { AppLoadingIndicator } from '@/components/ui/AppLoadingIndicator'
import { ROLES } from '@/constants/roles.constants'
import { useUserStore } from '@/stores/user.store'

// TODO: Type allowedRoles as Role[] instead of string[] once backend returns real roles (admin/user/manager)
// Currently backend returns "offline_access"
interface BaseGuardProps {
  // allowedRoles: Role[]  // turn back on when Role type is fixed
  allowedRoles: string[]
  redirectIfNotAuth: string
  children: ReactNode
}

export function BaseGuard({ allowedRoles, redirectIfNotAuth, children }: BaseGuardProps) {
  const user = useUserStore(s => s.user)
  const loading = useUserStore(s => s.loading)
  const sessionRestored = useUserStore(s => s.sessionRestored)

  if (!sessionRestored || loading) return <AppLoadingIndicator />

  if (!user) return <Navigate to={redirectIfNotAuth} replace />

  if (!allowedRoles.includes(user.role)) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

export function BackofficeGuard({ children }: { children: ReactNode }) {
  return (
    <BaseGuard allowedRoles={[ROLES.ADMIN]} redirectIfNotAuth="/bo/login">
      {children}
    </BaseGuard>
  )
}

export function AppGuard({
  allowedRoles,
  children,
}: {
  allowedRoles: string[]
  children: ReactNode
}) {
  return (
    <BaseGuard allowedRoles={allowedRoles} redirectIfNotAuth="/login">
      {children}
    </BaseGuard>
  )
}
